'use client'

import Link from 'next/link'

import { cn } from '@/lib/utils'
import { StarBorder } from '@/components/ui/star-border'

// The Zero-to-Hero apply CTA: a rounded-full dark pill (matching the header's
// "Get Your Free Audit" 100px radius + CTA family) whose gold light travels
// the border continuously — the idle, always-on animation — via ReactBits
// StarBorder. Hover is PURE CSS: a --z2h-star-speed variable the :hover rule
// overrides cascades into the glow's animationDuration (speeds it up), a gold
// glow blooms, and the arrow slides. No motion crosses the text; the face
// stays clean. Reduced-motion → a static gold-bordered dark pill.
export function StarBorderButton({ href, children, className = '' }) {
  return (
    <StarBorder
      as={Link}
      href={href}
      color="#F0D480"
      glowOpacity={1}
      speed="var(--z2h-star-speed, 5s)"
      thickness={2}
      className={cn(
        // Persistent gold glow halo so the pill reads as lit on the dark page;
        // hover intensifies it and speeds the traveling light.
        'group rounded-full shadow-[0_0_28px_rgba(201,168,76,0.45)] transition-shadow duration-300 [--z2h-star-speed:5s]',
        'hover:shadow-[0_0_48px_rgba(201,168,76,0.75)] hover:[--z2h-star-speed:2s]',
        'active:translate-y-px',
        className,
      )}
      innerClassName="flex items-center justify-center gap-2 rounded-full border-2 border-kingdom-gold/70 bg-gradient-to-b from-neutral-900 to-neutral-950 px-8 py-4 text-base font-semibold text-[#F5E5B8]"
    >
      {children}
      <span
        aria-hidden
        className="transition-transform duration-200 group-hover:translate-x-1 motion-reduce:transition-none"
      >
        →
      </span>
    </StarBorder>
  )
}
